<template>
    <div>
    <app-toolbaravatar :app_title="title" :app_avatar="form.medical_usersavatar" app_back="Y"></app-toolbaravatar>
    <v-card
    class="mt-15"
    outlined
    >
    <v-progress-linear
    indeterminate
    color="fourth"
    rounded
    v-if="loading.page"
    ></v-progress-linear>
    <v-card-title class="body-2 font-weight-bold">Ringkasan Reimburse Kesehatan</v-card-title>
    <v-card-text class="caption">
        <v-row align="center">
            <v-col cols="6">Tanggal Mulai</v-col><v-col cols="6" class="font-weight-bold">{{ $functions.FormatDateIndoWithDayName(form.medical_date) }}</v-col>
            <v-col cols="6" class="mt-n5" v-if="this.form.medical_type ==='I'">Tanggal Selesai</v-col><v-col cols="6" class="mt-n5 font-weight-bold" v-if="this.form.letter_type ==='I'">{{ $functions.FormatDateIndoWithDayName(form.medical_edate) }}</v-col>
            <v-col cols="6" class="mt-n5" v-if="this.form.medical_type ==='I'">Lama Rawat Inap</v-col><v-col cols="6" class="mt-n5 font-weight-bold" v-if="this.form.letter_type ==='I'">{{ form.medical_duration }} Hari</v-col>
            <v-col cols="6" class="mt-n5">Tipe</v-col><v-col cols="6" class="mt-n5 font-weight-bold">{{ form.medical_typedesc }}</v-col>
            <v-col cols="6" class="mt-n5">Pasien</v-col><v-col cols="6" class="mt-n5 font-weight-bold">{{ form.medical_patientdesc }}</v-col>
            <v-col cols="6" class="mt-n5">Alasan</v-col><v-col cols="6" class="mt-n5 font-weight-bold">{{ form.medical_remarks }}</v-col>
            <v-col cols="6" class="mt-n5">Biaya Jasa</v-col><v-col cols="6" class="mt-n5 text-right font-weight-bold">{{ $functions.NewFormatNumber(form.medical_services) }}</v-col>
            <v-col cols="6" class="mt-n5">Biaya Obat - Obatan</v-col><v-col cols="6" class="mt-n5 text-right font-weight-bold">{{ $functions.NewFormatNumber(form.medical_medicine) }}</v-col>
            <v-col cols="6" class="mt-n5">Biaya Administrasi</v-col><v-col cols="6" class="mt-n5 text-right font-weight-bold">{{ $functions.NewFormatNumber(form.medical_adminfee) }}</v-col>
            <v-col cols="6" class="mt-n5" v-if="this.form.medical_type ==='I'">Biaya Kamar Rawat Inap</v-col><v-col cols="6" class="mt-n5 text-right font-weight-bold" v-if="this.form.medical_type ==='I'">{{ $functions.NewFormatNumber(form.medical_rooms) }}</v-col>
            <v-col cols="6" class="mt-n5 body-1 font-weight-bold">Total</v-col><v-col cols="6" class="mt-n5 text-right font-weight-bold green--text body-1">{{ $functions.NewFormatNumber(form.medical_total) }}</v-col>
        </v-row>
    <v-divider></v-divider>
    <v-subheader class="body-2 font-weight-bold">Lampiran Utama &bull; <span class="primary--text ml-1" @click="$functions.OpenUrl(form.medical_attachmentpathurl)"><u>download file</u></span> <v-spacer></v-spacer></v-subheader>
    <div v-if="$functions.CheckImage(form.medical_attachmentpathurl)"><v-img :src="form.medical_attachmentpathurl"></v-img></div>
    <div class="primary--text font-weight-black mb-4" v-else @click="$functions.OpenUrl(form.medical_attachmentpathurl)">Filename : {{form.medical_attachmentpath}}</div>
    <v-btn color="primary" @click="Confirm('approve')" block class="mb-2" v-if="form.medical_status === 'R' && form.medical_leaderuser === $functions.UsersID()">Setuju</v-btn>
    <v-btn color="red" @click="Confirm('reject')" block v-if="form.medical_status === 'R' && form.medical_leaderuser === $functions.UsersID()">Tolak</v-btn>
    <v-btn color="primary" @click="Confirm('hr')" block class="mb-2" v-if="form.medical_status === 'L' && form.hr_user === $functions.UsersID()">Setuju HR</v-btn>
    <v-btn color="red" @click="Confirm('reject')" block v-if="form.medical_status === 'L' && form.hr_user === $functions.UsersID()">Tolak HR</v-btn>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-title class="body-2 font-weight-bold">Lampiran Tambahan</v-card-title>
    <app-attachment-list dialog_modul="medical" :dialog_refno="form.medical_id" dialog_flag="Y"></app-attachment-list>
    <v-divider></v-divider>
    <v-card-title class="body-2 font-weight-bold">Timeline</v-card-title>
    <v-timeline
            align-top
            dense
          >
            <v-timeline-item
              color="green"
              small
            >
              <div>
                <div class="caption">
                    created:<strong> {{ form.medical_cuser }}</strong> &bull; {{ $functions.FormatDateTime(form.medical_cdate) }}
                </div>
              </div>
            </v-timeline-item>
            <v-timeline-item
              :color="$functions.FormatDateTime(form.medical_hrdate)?'green':'yellow'"
              small
              v-if="form.medical_hruser"
            >
              <div>
                <div class="caption">
                    hr:<strong> {{ form.medical_hruser }}</strong> &bull; {{ $functions.FormatDateTime(form.medical_hrdate) }}
                </div>
              </div>
            </v-timeline-item>
            <v-timeline-item
              color="red"
              small
              v-if="form.medical_rejectuser"
            >
              <div>
                <div class="caption">
                    reject:<strong> {{ form.medical_rejectuser }}</strong>&bull;{{ $functions.FormatDateTime(form.medical_rejectdate) }}
                </div>
              </div>
            </v-timeline-item>
          </v-timeline>
    </v-card>
    <v-alert
    border="left"
    colored-border
    color="secondary"
    elevation="2"
    v-if="form.medical_notes"
    >
    <div v-html="form.medical_notes"></div>
    </v-alert>
    <v-dialog v-model="confirm.dialog" max-width="490" persistent>
        <v-card>
            <v-card-title class="secondary headline white--text">{{confirm.title}}</v-card-title>
            <v-card-text>
                {{confirm.text}}
                <v-text-field 
                    v-model="confirm.notes"
                    prepend-inner-icon="notes"
                    placeholder="Catatan"
                    label="Catatan"
                    required
                    solo-inverted
                    outlined
                    class="mt-3"
                    id="confirmnotes"
                ></v-text-field>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary" outlined @click.stop="confirm.dialog = false">{{confirm.close}}</v-btn>
                <v-btn id="dialog_confirm_true" color="primary" outlined :disabled = "confirm.ok !== 'OK' ? true:false" @click="Loading">{{confirm.ok}}</v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>
    <app-snackbar 
        :dialog="snackbar.dialog"
        :color="snackbar.color"
        :text="snackbar.text"
        :timeout="snackbar.timeout"
        @close="snackbar.dialog = false"
    ></app-snackbar>
    </div>
</template>
<script>
    export default {
        data: () => ({
            title: '',
            loading: {
                page: false
            },
            form: {
                medical_id: '',
                medical_date: '',
                medical_edate: '',
                medical_usersid: '',
                medical_type: '',
                medical_typedesc: '',
                medical_balance: 0,
                medical_patient: '',
                medical_patientdesc: '',
                medical_remarks: '',
                medical_duration: 0,
                medical_services: 0,
                medical_medicine: 0,
                medical_adminfee: 0,
                medical_rooms: 0,
                medical_total: 0,
                medical_attachmentpath: '',
                medical_attachmentpathurl: '',
                medical_notes: '',
                medical_hrdate: '',
                medical_hruser: '',
                medical_rejectdate: '',
                medical_rejectuser: '',
                medical_cdate: '',
                medical_cuser: '',
                medical_leaderuser: '',
                hr_user: '',
                uploadinfo: '',
                uploadattach: '',
            },
            confirm: {
                dialog: false,
                title: '',
                text: '',
                ok: 'OK',
                close: 'Tutup',
                notes: '',
            },
            snackbar: {
                dialog: false,
                timeout: 3000,
                text: '',
                color: 'error'
            },
        }),
        created() {
            this.FirstLoad()
        },
        methods: {
            FirstLoad () {
                this.loading.page = true
                let decode = this.$functions.DecodeUrl(this.$route.params.id)
                let formdata = {
                  medical_id: decode,
                }
                let param 	   = this.$functions.ParamPOST(formdata)
                this.$axios.post(this.$functions.UrlPOST('apiListMedical'),param,{
                    headers: {
                        'Content-Type': 'text/plain; charset=ISO-8859-1'
                    }
                })
                .then(response => {
                    let feedback = response.data
                    if (feedback.length > 0) {
                        if (feedback[0].feedback === 'Y') {
                            this.title = feedback[0].medical_id
                            this.form.medical_id = feedback[0].medical_id
                            this.form.medical_date = feedback[0].medical_date
                            this.form.medical_edate = feedback[0].medical_edate
                            this.form.medical_duration = feedback[0].medical_duration
                            this.form.medical_type = feedback[0].medical_type
                            this.form.medical_typedesc = feedback[0].medical_typedesc
                            this.form.medical_services = feedback[0].medical_services
                            this.form.medical_medicine = feedback[0].medical_medicine
                            this.form.medical_adminfee = feedback[0].medical_adminfee
                            this.form.medical_rooms = feedback[0].medical_rooms
                            this.form.medical_total = feedback[0].medical_total
                            this.form.medical_patientdesc = feedback[0].medical_patient
                            this.form.medical_remarks = feedback[0].medical_remarks
                            this.form.medical_usersid = feedback[0].medical_usersid
                            this.form.medical_usersavatar = feedback[0].medical_usersavatarurl
                            this.form.medical_status = feedback[0].medical_status
                            this.form.medical_statusdesc = feedback[0].medical_statusdesc
                            this.form.medical_rejectuser = feedback[0].medical_rejectuser
                            this.form.medical_rejectdate = feedback[0].medical_rejectdate
                            this.form.medical_notes = feedback[0].medical_notes
                            this.form.medical_attachmentpath = feedback[0].medical_attachmentpath
                            this.form.medical_attachmentpathurl = feedback[0].medical_attachmentpathurl
                            this.form.medical_cuser = feedback[0].medical_cuser
                            this.form.medical_cdate = feedback[0].medical_cdate
                            if  (feedback[0].medical_status === 'L') {
                                this.CheckHR()
                            }
                            this.loading.page = false
                        } else {
                            this.SnackBar(true, 'error', feedback[0].feedback, 3000)
                            this.loading.page = false
                        }
                    } else {
                        this.SnackBar(true, 'error', this.$functions.ErrorCode(), 3000)
                        this.loading.page = false
                    }
                })
                .catch(e => {
                    this.SnackBar(true, 'error', e, 3000)
                    this.loading.page = false
                })
            },
            CheckHR () {
                this.loading.page = true
                let formdata = {
                  users_type: 'HR-MGR',
                  flag: 'mobileapp',
                  users_company: this.$functions.UsersCompany(),
                }
                let param 	   = this.$functions.ParamPOST(formdata)
                this.$axios.post(this.$functions.UrlPOST('apiListUsersShort'),param,{
                    headers: {
                        'Content-Type': 'text/plain; charset=ISO-8859-1'
                    }
                })
                .then(response => {
                    let feedback = response.data
                    if (feedback.length > 0) {
                        if (feedback[0].feedback === 'Y') {
                            this.form.hr_user = feedback[0].users_id
                            this.loading.page = false
                        } else {
                            this.SnackBar(true, 'error', feedback[0].feedback, 3000)
                            this.loading.page = false
                        }
                    } else {
                        this.SnackBar(true, 'error', this.$functions.ErrorCode(), 3000)
                        this.loading.page = false
                    }
                })
                .catch(e => {
                    this.SnackBar(true, 'error', e, 3000)
                    this.loading.page = false
                })
            },
            Confirm (flag) {
                if (flag === 'approve') {
                    this.url_type = flag
                    this.confirm.dialog   = true
                    this.confirm.title    = 'Setuju'
                    setTimeout(function(){
                    document.getElementById('dialog_confirm_true').focus()
                    }, 500)
                } else if (flag === 'hr') {
                    this.url_type = flag
                    this.confirm.dialog   = true
                    this.confirm.title    = 'Setuju HR'
                    setTimeout(function(){
                    document.getElementById('dialog_confirm_true').focus()
                    }, 500)
                } else if (flag === 'reject') {
                    this.url_type = flag
                    this.confirm.dialog   = true
                    this.confirm.title    = 'Tolak'
                    setTimeout(function(){
                    document.getElementById('dialog_confirm_true').focus()
                    }, 500)
                }
            },
            Loading () {
                if (this.confirm.notes === '') {
                    this.SnackBar(true, 'success', 'Mohon isi catatan', 3000)
                    setTimeout(function(){
                    document.getElementById('confirmnotes').focus()
                    }, 500)
                } else {
                    this.confirm.ok = 'Loading...'
                    this.Write()
                }
            },
            Write () {
                let formdata = {
                  url_type: this.url_type,
                  medical_id: this.form.medical_id,
                  medical_notes: this.confirm.notes,
                }
                let param 	   = this.$functions.ParamPOST(formdata)
                this.$axios.post(this.$functions.UrlPOST('apiWriteMedical'),param,{
                    headers: {
                        'Content-Type': 'text/plain; charset=ISO-8859-1'
                    }
                })
                .then(response => {
                    let feedback = response.data
                    if (feedback.length > 0) {
                        if (feedback[0].feedback === 'Y') {
                            let flag = ''
                            if (this.url_type === 'approve') {
                                flag = 'Setuju'
                                this.form.medical_status = 'L'
                                this.form.medical_statusdesc = 'UnApprove HR'
                            } else if (this.url_type === 'reject') {
                                flag = 'Tolak'
                                this.form.medical_status = 'J'
                                this.form.medical_statusdesc = 'Reject'
                            } else if (this.url_type === 'hr') {
                                flag = 'Setuju HR'
                                this.form.medical_status = 'A'
                                this.form.medical_statusdesc = 'Approve'
                            }
                            this.SnackBar(true, 'success', flag+' Sukses', 3000)
                            this.confirm.dialog  	 = false
                            this.confirm.text 	 	 = 'Ok'
                        } else {
                            this.SnackBar(true, 'error', feedback[0].feedback, 3000)
                        }
                    } else {
                        this.SnackBar(true, 'error', this.$functions.ErrorCode(), 3000)
                    }
                })
                .catch(e => {
                    this.SnackBar(true, 'error', e, 3000)
                })
            },
            SnackBar (dialog, color, text, timeout) {
                this.snackbar = {
                    dialog: dialog,
                    color: color,
                    text: text,
                    timeout: timeout
                }
                if (color === 'error') {
                    this.confirm.dialog 	 = false
                    this.confirm.ok 	 	 = 'OK'
                }
            }
        }
    }
</script>